class CurrencyMegamenu extends HTMLElement {
  connectedCallback() {
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      form: this.querySelector('form'),
      country: this.querySelector('.country-name'),
      currencyCode: this.querySelector('.currency-code'),
      currencySymbol: this.querySelector('.currency-symbol'),
      countryItems: this.querySelectorAll('.currency-location a')
    };

    this.elements.countryItems.forEach(item => 
      item.addEventListener('click', this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    const el = event.target;
    this.addActiveClass(el);

    if (this.elements.country) {
      this.elements.country.textContent = el.dataset.countryName;
    }
    if (this.elements.input) {
      this.elements.input.value = el.dataset.isoCode;
    }

    const currentCurrency = document.querySelector('.current-currency');
    if (currentCurrency) {
      currentCurrency.textContent = `${el.dataset.isoCode} / ${el.dataset.currencyCode}`;
    }

     setTimeout(() => {
      this.elements.form.submit();
    }, 300); 
  }

  addActiveClass(el) {
    this.elements.countryItems.forEach(item => {
      item.parentElement.classList.remove('active');
    });
    el.parentElement.classList.add('active');
  }
}

customElements.define('currency-megamenu', CurrencyMegamenu);